import { render, staticRenderFns } from "./myuserpromise.vue?vue&type=template&id=064912a8&scoped=true"
import script from "./myuserpromise.vue?vue&type=script&lang=js"
export * from "./myuserpromise.vue?vue&type=script&lang=js"
import style0 from "./myuserpromise.vue?vue&type=style&index=0&id=064912a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064912a8",
  null
  
)

export default component.exports